/**
 * Descarga de reportes en CSV (DAF v2, sección 27; pedido explícito del
 * usuario -- "quiero poder descargar inform de venta de inventarios y
 * demás"). Se eligió CSV en vez de un .xlsx con formato porque abre
 * directamente en Excel/Sheets/LibreOffice sin ninguna librería adicional
 * -- coherente con la restricción de $0 costo de todo el proyecto (una
 * librería de generación de .xlsx con formato real, tipo ExcelJS, agrega
 * peso al bundle sin necesidad real para "puedo llevarme esta tabla a
 * Excel", que es lo que se pidió).
 *
 * Todo corre en el navegador de la clienta, sin backend: arma el texto
 * CSV, lo mete en un Blob y dispara la descarga con un <a download>
 * temporal -- patrón estándar del navegador, no depende de ninguna
 * librería externa.
 */

/** Escapa un valor para una celda CSV: si contiene coma, comilla o salto
 * de línea, lo envuelve en comillas dobles y duplica las comillas
 * internas (regla estándar del formato CSV, RFC 4180). */
function escaparCelda(valor: string | number): string {
  const texto = String(valor);
  if (/[",\n]/.test(texto)) {
    return `"${texto.replace(/"/g, '""')}"`;
  }
  return texto;
}

/**
 * Arma un CSV a partir de encabezados y filas, y dispara su descarga con
 * el nombre de archivo indicado (se le agrega ".csv" si no lo trae).
 *
 * Se antepone un BOM UTF-8 (`﻿`) al contenido: sin él, Excel en
 * Windows interpreta el archivo como ANSI/Latin-1 y las tildes y la "ñ"
 * de los reportes en español se ven corrompidas al abrirlo -- con el BOM,
 * Excel detecta UTF-8 correctamente. No hace falta para abrirlo en
 * Sheets/LibreOffice/una hoja de cálculo cualquiera, pero tampoco los
 * afecta.
 */
export function descargarCSV(nombreArchivo: string, encabezados: string[], filas: (string | number)[][]) {
  const lineas = [encabezados, ...filas].map((fila) => fila.map(escaparCelda).join(','));
  const contenido = '﻿' + lineas.join('\r\n');

  const blob = new Blob([contenido], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const nombreFinal = nombreArchivo.toLowerCase().endsWith('.csv') ? nombreArchivo : `${nombreArchivo}.csv`;

  const enlace = document.createElement('a');
  enlace.href = url;
  enlace.download = nombreFinal;
  document.body.appendChild(enlace);
  enlace.click();
  document.body.removeChild(enlace);
  URL.revokeObjectURL(url);
}
